import React, { useEffect, useRef, useState, useContext } from "react";
import {
  LowerWrapper,
  ContainerIteration,
  RadioSurvey,
  GeneralStyle,
  UpperWrapper,
  VSection,
  EditSection,
  QuestionWrapper,
  SelectsSection,
  ContainerButtons,
  ContainerTitle,
  AddDependency,
  EditButton,
  DeleteButton,
  CloneButton,
  SaveToBank,
  TooltipCheckSection,
  TooltipDescriptionContainer,
} from "./QuestionYesNoBox.styled";
import {
  StyledButton,
  StyledButtonGenericQuestion,
} from "../../containers/SurveyPreviewPanel/SurveyPreviewPanel.styled";
import { theme as themeConfig } from "../../themes/themes";
import StyleQuestionContainer from "../../containers/StyleQuestionContainer/index";
import MessageYesNo from "../MessageYesNo/index";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { ReactComponent as DeleteQuestion } from "../../themes/Icons/delete-question.svg";
import { ReactComponent as CancelQuestion } from "../../themes/Icons/cancel-question.svg";
import { ReactComponent as StyleQuestion } from "../../themes/Icons/style-question.svg";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DependentQuestions from "../DependentQuestions/DependentQuestions";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { ReactComponent as CloneIcon } from "../../assets/svg/add-square-icon.svg";
import ModalSaveToBank from "../ModalSaveToBank";
import InfoIcon from "@material-ui/icons/Info";

const RadioButtonComponent = ({
  elementKey,
  elementValue,
  setAnswerQuestion,
  alreadySaved,
  setshowDependency,
}) => {
  return (
    <RadioSurvey>
      <input
        type="radio"
        id={`radioButton-${elementKey}`}
        name="radioButton"
        defaultValue={elementValue}
        onChange={() => setAnswerQuestion(elementValue)}
      />
      <label id="labelRadioSurvey">{elementValue}</label>
      <AddDependency
        alreadySaved={alreadySaved}
        onClick={() => setshowDependency({ show: true, answer: elementValue })}
      >
        <AccountTreeIcon />
      </AddDependency>
    </RadioSurvey>
  );
};
const QuestionYesNoBox = ({
  title,
  setTitle,
  setAnswerQuestion,
  mandatory,
  setMandatory,
  editable,
  loadCategories,
  refTitle,
  setRefTitle,
  refIsMandatory,
  setRefIsMandatory,
  refValidationText,
  setRefValidationText,
  refCategory,
  setRefCategory,
  saveQuestionBank,
  handleEdit,
  handleCancel,
  configQuestionStyle,
  setconfigQuestionStyle,
  handleDeleteQuestion,
  idQuestionSurvey,
  saveDependencies,
  dependency,
  alreadySaved,
  globalProps,
  categories,
  identity,
  saveFormQuestion,
  tooltipInformationCheck,
  tooltipDescriptionText,
  setShowTooltipDescription,
  handleTextAreaText,
  changeTooltipInformationCheck,
  showTooltipDescription,
}) => {
  const [stateQuestionsReducer] = useContext(ContextQuestions);
  const [showDependency, setshowDependency] = useState({
    show: false,
    answer: "",
  });
  const rValidationText = useRef();
  const rCategory = useRef();
  const [colorBackground] = useState("#f9f9f9");
  const [showStyleEdit, setshowStyleEdit] = useState(false);
  const [openMessageYesNoModal, setOpenMessageYesNoModal] = useState(false);
  const [responseMessageYesNo, setResponse] = useState(false);
  const [showSaveToBank, setShowSaveToBank] = useState(false);
  const handleSaveToBank = () => {
    setShowSaveToBank(true);
  };
  useEffect(() => {
    if (responseMessageYesNo) {
      handleDeleteQuestion();
    }
  }, [responseMessageYesNo]);

  let handleTitleInput = (e) => {
    setTitle(e.target.value);
    setRefTitle(e.target.value);
  };

  let handleMandatory = (e) => {
    setMandatory(e.target.checked);
    setRefIsMandatory(e.target.checked);
  };

  let handleValidationtext = (e) => {
    setRefValidationText(e.target.value);
  };

  let handleRefCategory = (e) => {
    setRefCategory(e.target.value);
  };

  return (
    <>
      <GeneralStyle
        isDependent={globalProps.GisDependent}
        editable={editable}
        colorBackground={
          configQuestionStyle.customStyle
            ? configQuestionStyle.background
            : colorBackground
        }
      >
        {editable ? (
          <EditSection>
            <VSection>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mandatory}
                    onChange={(e) => handleMandatory(e)}
                    name="mandatory-check"
                  />
                }
                label="Mandatory Question"
              />
              {mandatory ? (
                <input
                  onChange={(e) => handleValidationtext(e)}
                  type="text"
                  placeholder="Enter mandatory message here"
                  id="mText"
                  ref={rValidationText}
                  defaultValue={refValidationText}
                ></input>
              ) : null}
            </VSection>
            <hr />
            <UpperWrapper>
              <QuestionWrapper>
                <label>Question:</label>
                <textarea
                  onChange={(e) => handleTitleInput(e)}
                  type="text"
                  placeholder="Enter your question here"
                  defaultValue={refTitle}
                ></textarea>
              </QuestionWrapper>
              {identity !== "form" && (
                <>
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      <SelectsSection>
                        <div>
                          <label>Category</label>
                          <select
                            onChange={(e) => handleRefCategory(e)}
                            ref={rCategory}
                            defaultValue={refCategory.toString()}
                          >
                            <option value={0}>- Category -</option>
                            {loadCategories()}
                          </select>
                        </div>
                      </SelectsSection>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "35px",
                        paddingTop: "20px",
                      }}
                    >
                      <TooltipCheckSection>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={tooltipInformationCheck}
                              onChange={(e) => {
                                changeTooltipInformationCheck(e.target.checked);
                              }}
                              name="tooltip-info-check"
                            />
                          }
                          label="Add information tooltip to question"
                        />
                      </TooltipCheckSection>
                    </Grid>
                  </Grid>
                  {tooltipInformationCheck && (
                    <Grid
                      container
                      style={{ display: "flex", alignContent: "flex-end" }}
                    >
                      <Grid item xs={12} sm={3}>
                        <></>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <TooltipDescriptionContainer>
                          <textarea
                            style={{ height: "80px", resize: "none" }}
                            onChange={(e) => handleTextAreaText(e.target.value)}
                            type="text"
                            placeholder="Type text here..."
                            id="tooltipDescription"
                            defaultValue={tooltipDescriptionText}
                          ></textarea>
                        </TooltipDescriptionContainer>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </UpperWrapper>
          </EditSection>
        ) : null}
        {refTitle ? (
          <LowerWrapper>
            <ContainerTitle
              style={
                configQuestionStyle.customStyle
                  ? configQuestionStyle.question
                  : stateQuestionsReducer.globalStyle.questions
              }
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                {title}
                {tooltipInformationCheck && tooltipDescriptionText !== "" && (
                  <Tooltip
                    placement="left"
                    open={showTooltipDescription}
                    title={
                      <>
                        <Box
                          style={{
                            margin: "0",
                            listStyleType: "circle",
                            lineHeight: "1.3",
                            fontSize: "13px",
                          }}
                        >
                          <span>{tooltipDescriptionText}</span>
                        </Box>
                      </>
                    }
                    arrow
                  >
                    <IconButton
                      onClick={() => {
                        setShowTooltipDescription(!showTooltipDescription);
                      }}
                    >
                      <InfoIcon
                        fontSize="small"
                        style={{
                          cursor: "pointer",
                          color: themeConfig.text.primary,
                          width: "18px",
                          height: "18px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </ContainerTitle>
          </LowerWrapper>
        ) : null}
        <ContainerIteration
          style={
            configQuestionStyle.customStyle
              ? configQuestionStyle.answer
              : stateQuestionsReducer.globalStyle.answers
          }
        >
          <RadioSurvey>
            <input
              type="radio"
              id={`radioButton-1`}
              name="radioButton"
              defaultValue="yes"
              onChange={() => setAnswerQuestion("yes")}
            />
            <label id="labelRadioSurvey">yes</label>
            {!globalProps.GisDependent && identity !== "form" && (
              <AddDependency
                alreadySaved={alreadySaved}
                onClick={() => setshowDependency({ show: true, answer: "yes" })}
              >
                <AccountTreeIcon />
              </AddDependency>
            )}
          </RadioSurvey>
          <RadioSurvey>
            <input
              type="radio"
              id={`radioButton-1`}
              name="radioButton"
              defaultValue="no"
              onChange={() => setAnswerQuestion("no")}
            />
            <label id="labelRadioSurvey">no</label>
            {!globalProps.GisDependent && identity !== "form" && (
              <AddDependency
                alreadySaved={alreadySaved}
                onClick={() => setshowDependency({ show: true, answer: "no" })}
              >
                <AccountTreeIcon />
              </AddDependency>
            )}
          </RadioSurvey>
        </ContainerIteration>
        {!editable && idQuestionSurvey && !globalProps.questionBank && (
          <div className="overlay-option">
            <div className="bottom-buttons">
              <CloneButton
                hidden={globalProps.disableButton}
                className="mx-3 w-25 mt-2 mb-3"
                onClick={() => {
                  if (identity !== "form") {
                    saveQuestionBank(true);
                  } else {
                    saveFormQuestion(true);
                  }
                }}
              >
                <CloneIcon />
                Clone
              </CloneButton>
              {identity !== "form" && (
                <SaveToBank
                  hidden={globalProps.disableButton}
                  className="w-25 mt-2 mb-3"
                  onClick={() => handleSaveToBank()}
                >
                  Save to bank
                </SaveToBank>
              )}
              <DeleteButton
                hidden={globalProps.disableButton}
                className="mx-3 w-25 mt-2 mb-3"
                onClick={() => setOpenMessageYesNoModal(true)}
              >
                Delete
              </DeleteButton>
              <EditButton
                hidden={globalProps.disableButton}
                className="w-25 mt-2 mb-3"
                onClick={() => handleEdit()}
              >
                Edit
              </EditButton>
            </div>
          </div>
        )}
        {editable && (
          <ContainerButtons>
            <div className="left-container">
              <StyledButtonGenericQuestion
                onClick={() => {
                  setshowStyleEdit(true);
                }}
              >
                <StyleQuestion />
                Style
              </StyledButtonGenericQuestion>
              {editable && idQuestionSurvey ? (
                <StyledButtonGenericQuestion onClick={() => handleCancel()}>
                  <CancelQuestion />
                  Cancel
                </StyledButtonGenericQuestion>
              ) : null}
              <StyledButtonGenericQuestion
                lastElement={true}
                onClick={() => setOpenMessageYesNoModal(true)}
              >
                <DeleteQuestion />
                Delete
              </StyledButtonGenericQuestion>
            </div>
            <div className="right-container">
              <StyledButton
                onClick={() => {
                  if (identity !== "form") {
                    saveQuestionBank(false);
                  } else {
                    saveFormQuestion(false);
                  }
                }}
              >
                Save
              </StyledButton>
            </div>
          </ContainerButtons>
        )}
        {showStyleEdit && (
          <StyleQuestionContainer
            hideAnswerStyle
            setshowStyleEdit={setshowStyleEdit}
            stateObject={configQuestionStyle}
            setstateObject={setconfigQuestionStyle}
          ></StyleQuestionContainer>
        )}
        {openMessageYesNoModal && (
          <MessageYesNo
            setOpenMessageYesNoModal={setOpenMessageYesNoModal}
            message="Are you sure you want to delete this question?"
            setResponse={setResponse}
          ></MessageYesNo>
        )}
      </GeneralStyle>
      {showDependency.show && (
        <DependentQuestions
          dependency={dependency}
          saveDependencies={saveDependencies}
          idQuestionSurvey={idQuestionSurvey}
          setshowDependency={setshowDependency}
          showDependency={showDependency}
        ></DependentQuestions>
      )}
      {showSaveToBank && (
        <ModalSaveToBank
          idQuestion={globalProps?.GidQuestionSurvey}
          category={refCategory}
          categories={categories}
          setModalVisibility={setShowSaveToBank}
        />
      )}
    </>
  );
};
export default QuestionYesNoBox;
